import React from 'react';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';
import tsResourcesUrl from './urls';
import TsResourcesComponent from '.';

const routes = [
    <AuthenticatedLayoutRoute
        path={tsResourcesUrl}
        key={tsResourcesUrl}
        allowedRoles={['TWIGADMIN', 'SUPERUSER', 'TEACHER']}
        withSwoosh
    >
        <TsResourcesComponent />
    </AuthenticatedLayoutRoute>,
];

export default routes;
